export default{
    data() {
        return {
            listData: [],
            loading: false,
            remainder: 0,
            pageNo: 1,
            total: 0,
            planIdShow: null
        }
    }
}